// @flow
import {
  REQUEST_LOCALES,
  REQUEST_LOCALES_SUCCESS,
  REQUEST_LOCALES_FAILED
} from "../actions/locales";
import type { Locale } from "../models/locale";
import type { ActionWithData, StateWithData } from "../helpers/types";

export type LocalesData = Array<Locale>;
export type LocalesState = StateWithData<LocalesData>;
export type LocalesAction = ActionWithData<LocalesData>;

export function locales(
  state: LocalesState = { data: [] },
  action: LocalesAction
): LocalesState {
  switch (action.type) {
    case REQUEST_LOCALES:
      return state;
    case REQUEST_LOCALES_SUCCESS:
      return {
        ...state,
        data: [...action.data],
        error: null
      };
    case REQUEST_LOCALES_FAILED:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/locales.js